export const features = {
  uiKit: import.meta.env.VITE_ENABLE_UI_KIT === 'true',
} as const;
